module.exports = __webpack_public_path__ + "media/promo/velle/images/top_products/prod_2__mob-bd49baf04af2e7dfb9174dffdf002218.png";